export const countryStrings = {
  country: {
    id: 'ID',
    name: 'Name',
    modified: 'Geändert',
    addendum: 'Zusatz',
    alpha2: 'Abkürzung (2)',
    alpha3: 'Abkürzung (3)',
    thirdLevel: 'Drittstaat',
    group: 'Gruppe',
  },
  entitySingular: 'Land',
  entityPlural: 'Länder',
  messages: {
    archive: {
      success: (name: string) => `Land "${name}" wurde archiviert`,
      error: 'Land konnte nicht archiviert werden',
    },
    restore: {
      success: (name: string) => `Land "${name}" wurde wiederhergestellt`,
      error: 'Land konnte nicht wiederhergestellt werden',
    },
    deletion: {
      success: (name: string) => `Country "${name}" wurde erfolgreich gelöscht`,
      error: 'Country konnte nicht gelöscht werden',
    },
    update: {
      success: 'Country erfolgreich aktualisiert',
      error: 'Country konnte nicht aktualisiert werden',
    },
    create: {
      success: 'Country erfolgreich erstellt',
      error: 'Country konnte nicht erstellt werden',
    },
    import: {
      title: 'Länder importieren',
      label: 'Länder importieren',
      selectFile: 'Excel-Datei auswählen',
      chooseFile: 'Datei auswählen',
      noFileSelected: 'Keine Datei ausgewählt',
      action: 'Importieren',
      success: 'Länder erfolgreich importiert',
      error: 'Fehler beim Importieren der Länder',
      description:
        'Es wird die erste Tabelle der Excel-Datei eingelesen. Erforderliche Spalten (nach Spaltenüberschrift, Reihenfolge beliebig): „Abkürzung“ (Alpha-2-Code) und „Name“.',
      behavior:
        'Alle Länder, deren Abkürzung oder Name in der Datei enthalten ist, werden als „Kein Drittland“ markiert. Alle übrigen in der Datenbank vorhandenen Länder werden auf „Drittland“ gesetzt.',
    },
  },
};
